import { objectArrayFromDiffFields } from "globalutils/fmUtils";

export const prepareVehicleLists = (vehicles, i18n) => {
    const activeVehicles = objectArrayFromDiffFields(vehicles?.vehicles, 'id', 'unit_id') || [];
    const deActivatedVehicles = objectArrayFromDiffFields(vehicles?.deactivatedVehicles, 'id', 'unit_id') || [];

    if (activeVehicles.length) {
        activeVehicles.unshift({ label: i18n.t('users.All'), value: '' });
    }
    if (deActivatedVehicles.length) {
        deActivatedVehicles.unshift({ label: i18n.t('users.All'), value: '' });
    }

    return { activeVehicles, deActivatedVehicles };
};